// src/pages/NotFound.tsx
import React from 'react';

export default function NotFound() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Страница не найдена</h2>
      <p>Проверь адрес или вернитесь на главную.</p>
    </div>
  );
}
